var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center text-danger my-2"},[_c('b-spinner',{staticClass:"align-middle mr-2",attrs:{"small":""}}),_c('strong',[_vm._v("Loading...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }